import { Route, Routes } from 'react-router-dom';
import About from '../pages/About/About';
import Home from '../pages/Home/Home';
import Performance from '../pages/Performance/Performance';
import Pricing from '../pages/Pricing/Pricing';
import PrivacyPolicy from '../pages/Privacy/Privacy';
import Refund from '../pages/Refund/Refund';
import Terms from '../pages/Terms/Terms';
import Account from "../pages/Account/Account";

const Router = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/pricing" element={<Pricing />} />
    <Route path="/about" element={<About />} />
    <Route path="/performance" element={<Performance />} />
    <Route path="/privacy" element={<PrivacyPolicy />} />
    <Route path="/refund" element={<Refund />} />
    <Route path="/terms" element={<Terms />} />
    <Route path="/my-account" element={<Account />} />
  </Routes>
);

export default Router;
